var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.5 14.2495C10.9518 14.2495 13.75 11.4513 13.75 7.99951C13.75 4.54773 10.9518 1.74951 7.5 1.74951C4.04822 1.74951 1.25 4.54773 1.25 7.99951C1.25 11.4513 4.04822 14.2495 7.5 14.2495Z",
    fill: "#8AEBA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61252 10.237C6.48752 10.237 6.36877 10.187 6.28127 10.0995L4.51252 8.33076C4.33127 8.14951 4.33127 7.84951 4.51252 7.66826C4.69377 7.48701 4.99377 7.48701 5.17502 7.66826L6.61252 9.10576L9.82502 5.89326C10.0063 5.71201 10.3063 5.71201 10.4875 5.89326C10.6688 6.07451 10.6688 6.37451 10.4875 6.55576L6.94377 10.0995C6.85627 10.187 6.73752 10.237 6.61252 10.237Z",
    fill: "#1B9E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationSuccess);
export default __webpack_public_path__ + "static/media/validation-success.483a3bcc4f629991421348df043e89c3.svg";
export { ForwardRef as ReactComponent };